export default {
  restaurantabout: {
    for: "لـ",
    restaurants: "المطاعم",

    title1: "احصل على مكونات طازجة",
    title2: "من",
    highlight: "موردين موثوقين",

    desc:
      "تساعد MAHAL المطاعم على تبسيط عمليات التوريد من خلال ربطها بموردين موثوقين للتوريد اليومي وبالكميات الكبيرة.",

    text:
      "من المطابخ المستقلة إلى سلاسل المطاعم متعددة الفروع، تمكّن MAHAL المطاعم من الوصول إلى موردين موثوقين وأسعار شفافة وطلبات مجمعة بسهولة — كل ذلك عبر منصة موحدة.",

    li1: "موردون موثوقون",
    li2: "تسعير شفاف",
    li3: "طلبات يومية وبكميات كبيرة",
    li4: "توصيل في الوقت المحدد",

    cta: "اطلب لمطعمك",
  },
};